export function isZipcodeValid(zipcode: string) {
  const regex = /^\d{5}-\d{3}$/

  return regex.test(zipcode)
}
